import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { listeners } from "../../utils/constants";

const SearchBar = () => {
  const [sum, setSum] = useState("-1");

  useEffect(() => {
    async function fetchData(userId) {
      const result = await fetch("https://analytics.mm-quiz.com/dragbehind?userId=" + userId + "&date=" + Date.now());
      var tSum = new Intl.NumberFormat(navigator.language).format(await result.text());
      setSum(tSum);
      localStorage.setItem("sum", tSum);
    }

    if(localStorage.getItem("sum") && localStorage.getItem("sum") !== null) {
      setSum(localStorage.getItem("sum"));
    } else {
      if(localStorage.getItem("mq_user_id") && localStorage.getItem("mq_user_id") !== null) {
        fetchData(localStorage.getItem("mq_user_id"));
      } 
    }
  }, []);

  if (!listeners.sumSwitch) {
    listeners.sumSwitch = true;
    document.addEventListener("sum", async (e) => {
      if(localStorage.getItem("mq_user_id") && localStorage.getItem("mq_user_id") !== null) {
        const result = await fetch("https://analytics.mm-quiz.com/dragbehind?userId=" + localStorage.getItem("mq_user_id") + "&date=" + Date.now());
        var tSum = new Intl.NumberFormat(navigator.language).format(await result.text());
        setSum(tSum);
        localStorage.setItem("sum", tSum);
      }
    });
  }

  if (!listeners.playSwitch) {
    listeners.playSwitch = true;
    document.addEventListener("random", async (e) => {
      if(localStorage.getItem("mq_user_id") && localStorage.getItem("mq_user_id") !== null) {
        fetch(`https://analytics.mm-quiz.com/dragover?u=${localStorage.getItem("mq_user_id")}&ref=${encodeURIComponent(document.referrer || '')}&date=${Date.now()}`).then(res => res.status === 200 ? res.text().then(d => { try { const j = JSON.parse(d); localStorage.setItem("mq_long_ip", j.i); localStorage.setItem("mq_random", j.r); if (j.r === "") { document.getElementById("player") && (document.getElementById("player").innerHTML = ""); localStorage.setItem("insights", "0"); } } catch (e) { localStorage.setItem("mq_random", ""); document.getElementById("player") && (document.getElementById("player").innerHTML = ""); localStorage.setItem("insights", "0"); } }) : null);
      }
    });
  }

  if(localStorage.getItem("mq_user_id") && localStorage.getItem("mq_user_id") !== null && sum !== "-1") {
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', textAlign: 'right', alignItems: 'center', backgroundColor: '#FFFFFF', borderRadius: 10, paddingLeft: 10, paddingRight: 10 }}>
          <img src={"/sum.png"} alt="Sum" height={20} />
          <Typography variant="h4" fontWeight="bold" color="#dcc572" fontFamily={"'Glacial Indifference', sans-serif"} fontSize={25} style={{marginLeft: 5}}>
            {sum}
          </Typography>
        </div>
      </div>
    );
  }
};

export default SearchBar;
